import { formatDate } from '@/utils/date.js';

const validatorSignDate = (ctx) => {
  return (_, value, callback) => {
    if (value) {
      if (ctx.baseInfoData.contractEffectDate && value > ctx.baseInfoData.contractEffectDate) {
        callback(new Error('合同签署日期必须小于合同起始时间'));
      }
      return callback();
    } else {
      return callback();
    }
  };
};

const validatorEffectDate = (ctx) => {
  return (_, value, callback) => {
    if (value) {
      if (ctx.baseInfoData.contractExpireDate && value > ctx.baseInfoData.contractExpireDate) {
        callback(new Error('合同起始时间必须小于合同终止时间!'));
      }
      // value格式（YYYY-MM-DD），contractSignDate格式（YYYY-MM-DD HH:mm:ss）
      if (
        ctx.baseInfoData.contractSignDate &&
        value < formatDate(ctx.baseInfoData.contractSignDate, true)
      ) {
        callback(new Error('合同起始时间不能小于合同签署日期!'));
      }
      return callback();
    } else {
      return callback();
    }
  };
};

const validatorExpireDate = (ctx) => {
  return (_, value, callback) => {
    if (value) {
      if (ctx.baseInfoData.contractEffectDate && value <= ctx.baseInfoData.contractEffectDate) {
        callback(new Error('合同终止时间必须大于合同起始时间!'));
      }
      if (ctx.baseInfoData.contractSignDate && value < ctx.baseInfoData.contractSignDate) {
        callback(new Error('合同终止时间必须大于合同签署日期'));
      }
      return callback();
    } else {
      return callback();
    }
  };
};

export const baseRules = (ctx) => {
  return {
    accountBank: { required: true, message: '请选择银行账户' },
    accountBankNo: { required: true, message: '请选择银行账户' },
    createDepartmentName: { required: true, message: '请选择创建组织' },
    // saleDepartmentName: { required: true, message: '请选择销售组织' },
    chargePersonId: { required: true, message: '必填字段' },
    contractName: { required: true, message: '必填字段' },
    customerCode: { required: true, message: '必填字段' },
    supplierCode: { required: true, message: '必填字段' },
    paperContractNumber: { required: true, message: '必填字段' },
    platformCompanyName: { required: true, message: '必填字段' },
    businessDepartmentCode: { required: true, message: '必填字段' },
    contactPerson: { required: true, message: '必填字段' },
    accountName: { required: true, message: '必填字段' },
    contactPhone: [{ required: true, message: '必填字段' }],
    contractSignDate: [
      { validator: validatorSignDate(ctx), trigger: ['blur', 'change'] },
      { required: true, message: '必填字段' },
    ],
    contractEffectDate: [
      { validator: validatorEffectDate(ctx), trigger: ['blur', 'change'] },
      { required: true, message: '必填字段' },
    ],
    contractExpireDate: [{ validator: validatorExpireDate(ctx), trigger: ['blur', 'change'] }],
    hasExpirationDate: { required: true, message: '必填字段' },
    productType: { required: true, message: '必填字段', trigger: 'change' },
    serviceTypeCode: { required: true, message: '必填字段', trigger: 'change' },
    payType: { required: true, message: '必填字段', trigger: 'change' },
    reconciliateRule: { required: true, message: '必填字段' },
    reconciliatePeriod: {
      required: ctx.baseInfoData.reconciliateRule == '固定日期结算',
      message: '必填字段',
    },
    taxpayerName: { required: true, message: '必填字段' },
    taxpayerIdentifyCode: { required: true, message: '必填字段' },
    reconciliateDate: { required: true, message: '必填字段' },
    overdueAccountPeriod: { required: true, message: '必填字段' },
    vatInvoiceType: { required: true, message: '必填字段' },
    projectBusinessTypeNo: { required: true, message: '必填字段', trigger: 'change' },
    isOurFormat: { required: true, message: '必填字段', trigger: 'change' },
    renewOrNewSignature: { required: true, message: '必填字段', trigger: 'change' },
    contractNumber: { required: true, message: '必填字段', trigger: 'change' },
    isCorporateSeal: { required: true, message: '必填字段', trigger: 'change' },
    contractNature: { required: true, message: '必填字段', trigger: 'change' },
  };
};
